import {disableScrolling, enableScrolling} from '../utils/scroll-lock';

const $header = document.querySelector('.header') || false;
const $menuToggleButton = document.querySelector('.js-menu-toggle') || false;

const alignMenu = () => {
  if ($header) {
    const $menuInner = $header.querySelector('.header__menu-inner') || false;
    const menuHeight = $menuInner.offsetHeight;
    const isMenuTop = (window.innerHeight - menuHeight - 200) < 0;

    if (isMenuTop) {
      $header.classList.add('header--menu-top');
    } else {
      $header.classList.remove('header--menu-top');
    }
  }
};

const toggleMenu = () => {
  if ($header && $menuToggleButton) {
    const $menuButtonInner = $menuToggleButton.querySelector('span');
    const isMenuOpen = $header.classList.contains('header--menu-open');

    if (isMenuOpen) {
      $header.classList.remove('header--menu-open');
      $menuButtonInner.textContent = 'Меню';
      enableScrolling();
    } else {
      $header.classList.add('header--menu-open');
      $menuButtonInner.textContent = 'Закрыть';
      disableScrolling();
      alignMenu();
    }
  }
};

const addMenuListeners = () => {
  setTimeout(() => {
    $header.classList.add('can-animate');

    if ($menuToggleButton) {
      $menuToggleButton.addEventListener('click', () => {
        $menuToggleButton.blur();
        toggleMenu();
      });
    }
  }, 600);

  window.addEventListener('resize', () => {
    alignMenu();
  });
};

export {toggleMenu, addMenuListeners};
